import { INITIALIZE_PRODUCTS_FORM } from '../actionTypes';
import { installerProfileActions } from '../reducer';

export default (values) =>
    installerProfileActions[INITIALIZE_PRODUCTS_FORM](values);
